import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import parse from 'html-react-parser';
import { Container } from '@mui/system';

const Home = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    const fetchHtml = async () => {
      try {
        const data = await fetch('api-docs.html');
        const html = await data.text();

        if (html) {
          setContent(html);
        }
      } catch (error) {
        console.error('Error fetching HTML:', error);
      }
    };
    fetchHtml();
  }, []);

  return (
    <main>
      {content ? (
        parse(content)
      ) : (
        <Container
          sx={{
            height: '30vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Container>
      )}
    </main>
  );
};

export default Home;
